import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  html {\n    font-size: ", "%;\n    ", " {\n      font-size: ", "%;\n    }\n    ", " {\n      font-size: ", "%;\n    }\n    ", " {\n      font-size: ", "%;\n    }\n    ", " {\n      font-size: ", "%;\n    }\n    font-weight: 200;\n    height: 100%;\n    position: relative;\n  }\n\n  * {\n    font-family: 'Futura PT', Arial, sans-serif;\n    box-sizing: border-box;\n  }\n\n  body {\n    font-size: ", "rem;\n    height: 100%;\n    position: relative;\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n    background-color: ", ";\n  }\n\n  /* Remove Input Arrows Chrome, Safari, Edge, Opera */\n  input::-webkit-outer-spin-button,\n  input::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n\n  /* Firefox */\n  input[type=number] {\n    -moz-appearance: textfield;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
} // @flow


import { createGlobalStyle } from 'styled-components';
import { white } from './colors';
import { DEFAULT_FONTS } from './config';
import createMediaFunc from './media';
import createFontsFunc from './fonts';
export var createMedia = createMediaFunc;
export var createFonts = createFontsFunc;

var getFontSize = function getFontSize(size
/*: 'xl' | 'lg' | 'md' | 'sm' | 'xs' */
) {
  return function (pr) {
    return (62.5 * pr.fontSizes[size] || DEFAULT_FONTS[size]) / (pr.fontSizes.defaultFontSize || DEFAULT_FONTS.defaultFontSize);
  };
};

export var media = createMedia();
export var GlobalStyle = createGlobalStyle(_templateObject(), getFontSize('lg'), media.xl, getFontSize('xl'), media.md, getFontSize('md'), media.sm, getFontSize('sm'), media.xs, getFontSize('xs'), function (pr) {
  return pr.fontSizes.defaultFontSize / 10;
}, white());